var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOsonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7339 18.7856C17.3708 20.1571 15.6689 21.1409 13.8021 21.6364C11.9354 22.132 9.97085 22.1214 8.10949 21.6059C6.24834 21.1314 4.5518 20.1562 3.20308 18.7856C1.82838 17.4164 0.84712 15.7011 0.362527 13.82C-0.101868 12.0529 -0.120387 10.1977 0.308637 8.42166C0.73766 6.64558 1.60074 5.00446 2.82009 3.64622C4.03943 2.28798 5.57671 1.2553 7.29337 0.641276C9.01003 0.0272517 10.8521 -0.148822 12.6535 0.128925C14.455 0.406672 16.1592 1.12951 17.6125 2.23228C19.0659 3.33506 20.2227 4.78311 20.9787 6.44591C21.7347 8.10871 22.0661 9.93401 21.9431 11.7573C21.8201 13.5805 21.2465 15.3444 20.2741 16.89C19.8345 17.5568 19.3276 18.1765 18.7616 18.7394",
    fill: "#000F9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7307 18.7867C17.3677 20.1582 15.6657 21.142 13.799 21.6375C11.9322 22.1331 9.96767 22.1225 8.10632 21.607C8.10124 21.5953 8.09862 21.5827 8.09862 21.57C8.09862 21.5573 8.10124 21.5447 8.10632 21.533C7.61184 19.6649 7.61772 17.699 8.12335 15.8339C8.62898 13.9687 9.61648 12.2704 10.9861 10.9103C12.3558 9.55014 14.0591 8.57642 15.9241 8.0874C17.7891 7.59838 19.7498 7.61138 21.6082 8.12508C22.0094 9.59679 22.101 11.1361 21.8771 12.6452C21.6532 14.1542 21.1188 15.6002 20.3078 16.8911C19.8682 17.5579 19.3613 18.1776 18.7953 18.7405",
    fill: "#4DBBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsonIcon);
export default __webpack_public_path__ + "static/media/oson_icon.7bffa2107d0bebec9043906e3b33355d.svg";
export { ForwardRef as ReactComponent };